import React, {CSSProperties, useContext, useEffect, useRef, useState} from 'react';
import {
    Player,
    STATION_ACTION,
    StationAction,
    Station,
    SMALL,
    PlayerContext,
    PlayerContextDispatch
} from "../PlayerReducer";
import classnames from 'classnames';
// @ts-ignore

import Slide from "./Slide";

//import './Stations.less';




export const Stations = () => {

    const player = useContext(PlayerContext);
    const dispatch = useContext(PlayerContextDispatch);

    const {
        styleLoaded,
        station,
        stations,
        status,
        size
    } = player;

    const [position, setPosition] = useState(0);
    const liRefs = useRef<(HTMLLIElement|null)[]>([])
    const ulRef = useRef<HTMLUListElement|null>();
    const [slideData, setSlideData] = useState({ pocet: 0, posun: 0})
   // const posun = useRef(0);


    const hasstation = station;


    const count = stations.length/2;
    let first = Math.round(count);
    let last = Math.round(count);

    if (first === last)
        last--;

    if (first < slideData.pocet || size == SMALL)
        last = 10000;



    useEffect(()=> {


        let newSlideData = {
            posun: 0,
            pocet: 0
        }

        if (stations.length && ulRef.current != null && liRefs.current[0]) {

            const ul = ulRef.current;

            const padL = parseFloat(window.getComputedStyle(ul).getPropertyValue('padding-left') || '0');
            const padR = parseFloat(window.getComputedStyle(ul).getPropertyValue('padding-right') || '0');
            const marginR = parseFloat(window.getComputedStyle(liRefs.current[0]).getPropertyValue('margin-right') || '0')*2;
            const pocet = Math.floor((ul.offsetWidth - padL - padR) / (liRefs.current[0]?.offsetWidth+marginR));


            let baseposun = 0;
            if (pocet < liRefs.current.length)
            {
                const left = liRefs.current[0];
                const right = liRefs.current[pocet];

                if (left && right) {
                    baseposun = right.offsetLeft - left.offsetLeft;
                }
            }
            const mpos = position * pocet + pocet - liRefs.current.length;
            let posun = baseposun * position;

            if (mpos > 0)
            {
                posun -= (liRefs.current[0].offsetWidth +marginR) * mpos
            }

            newSlideData = { pocet, posun };
        }
        if (newSlideData.posun !== slideData.posun || newSlideData.pocet !== slideData.pocet)
            setSlideData(newSlideData);

    }, [stations.length, position, styleLoaded])

    return <>{stations.reduce((output,currentValue, index)=>{
        if (index <= last)
            output[0].push(currentValue);
        else
            output[1].push(currentValue);
        return output;
    }, [
        [],
        []
    ] as Array<Array<Station>>).map((stations, rowindex)=>{

        if (!stations.length)
            return false;
        let forRef = 0;
        return <ul ref={(el)=>{
            if (!rowindex)
                ulRef.current = el;
        }} key={rowindex} className={classnames({
            'radiacz-list': true,
            'radiacz-list-first': rowindex == 0,
            'radiacz-list-second': rowindex == 1
        })}>
            {stations.map((station,index)=>{

                const style= {
                    backgroundImage: `url('${station.image}')`,
                }

                const classes = {
                    'radiacz-list-item': true,
                    'radiacz-list-item-first': index == 0 || index == first,
                    'radiacz-list-item-last' : index == stations.length-1 || index == last,
                    selected:false
                }

                let off = (ev:React.MouseEvent<HTMLAnchorElement,MouseEvent>)=>{
                    ev.preventDefault();
                    if (station !== hasstation || status ==='STOP') {
                        dispatch({
                            type: STATION_ACTION,
                            payload: station
                        } as StationAction)
                    }
                };

                if (station === hasstation ) {
                    classes.selected =true;
                    off=(ev)=>{
                        ev.preventDefault();
                    };
                }

                const properties: CSSProperties = { };
                properties.transform = `translateX( ${-slideData.posun}px)`;
                properties['WebkitTransform'] = `translateX( ${-slideData.posun}px)`;

                return <li ref={el=> { if (!rowindex) {
                    if (!el) // pri prekreslovani se vynulovava napred
                        return;
                    liRefs.current[forRef++] = el; }
                }} key={station.stationId}  className={classnames(classes)} style={properties}>
                    <span className={'radiacz-list-item-shadow'}/>
                    <a href={'#'} style={style} onClick={off}><span>{station.name}</span></a>
                </li>
            })}
        </ul>

    })}
    <Slide countPerPage={slideData.pocet} position={position} setPosition={setPosition}/>
    </>

}